import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';

import { IntervalType, Flock, WeekRegistration } from '../../models/flock.model';

export interface ImportDialogInputData extends AbstractDialogData {
  intervalTypes?: IntervalType[];
  weekNrs?: number;
  flock: Flock;
}

interface ImportDialogOutputModel {
  file: File;
  intervalType: IntervalType;
  weekRegistrations: WeekRegistration[];
}

@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  styleUrls: ['./import.component.scss'],
  standalone: false,
})
export class ImportComponent extends AbstractDialog<ImportDialogOutputModel> {
  previousWeek?: WeekRegistration;
  isNewRegistration = true;

  weekRegistrations: WeekRegistration[];
  currentWeekRegistration: WeekRegistration = {
    weekNr: 0,
    dayRegistrations: [],
    startDay: null,
    endDay: null,
    registrationData: {},
  };

  @ViewChild('file', { static: true }) inputFile: ElementRef<HTMLInputElement>;
  selectedFile: File;
  weekNrs: number;
  intervalTypes: IntervalType[] = [];
  formGroup = new FormBuilder().group({
    intervalTypeControl: [null, [Validators.required]],
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ImportDialogInputData,
    protected mdDialogRef: MatDialogRef<
      ImportComponent,
      AbstractDialogResultData<ImportDialogOutputModel>
    >,
  ) {
    super();
    this.intervalTypes = this.data.intervalTypes;
    this.weekNrs = this.data.weekNrs;
  }

  onFileSelected() {
    this.selectedFile = this.inputFile.nativeElement.files[0];
  }
}
